import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between mb-6">
      <div>
        {eyebrow ? (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-1.5 h-4 rounded-full bg-primary-500" />
            <span className="font-label text-xs tracking-[0.2em] uppercase text-primary-600">{eyebrow}</span>
          </div>
        ) : null}
        <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 font-heading">{title}</h2>
        {desc ? <p className="mt-1 text-sm text-foreground-600 max-w-2xl">{desc}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}